<template>
  <div class="control-group">
      <div class="control from">
          <label for="from">{{Language.say('composer.details.from')}}</label>
          <span class="select-wrapper" v-if="compose.identities.count > 1">
              <select id="from" v-model="compose.identity_index" @change="onFromChange(compose.identity_index)">
                  <option v-for="identity in compose.identities.index"
                    :value="identity.index"
                    :key="identity.id"
                  >
                      <slot v-if="identity.name">{{ identity.name + ' ' }}</slot>
                      <slot v-if="identity.email">{{ '<' + identity.email + '> ' }}</slot>
                      <slot v-if="identity.id">{{ '(' + identity.id + ')'}}</slot>
                  </option>
              </select>
          </span>


          <!-- <DropdownList class="identities-drop" v-if="identities_collection.count > 1">
                <template #select>
                  <ActionButton
                        class='clear'
                        :text='"identity.name"'
                    />
                </template>

                <template #options>
                    <ActionButton
                        v-for="identity in identities_collection.items"
                        :value="identity.index"
                        :selected="identity.default"
                        :key="identity.id"
                        :text='"identity.name"'

                    />

                </template>
            </DropdownList> -->
      </div>
  </div>
</template>

<script setup>
  import {defineEmits, defineProps} from 'vue';
  import Language                   from '@/js/Shared/Language/Language';
  import ActionButton               from '@/vue/Elements/Buttons/ActionButton.vue';
  import DropdownList               from '@/vue/Elements/DropDowns/DropdownList.vue';

  const emit  = defineEmits([
    'fromChange',
  ])

  const props = defineProps({
    compose : {}
  })

  const onFromChange = (index) => {
    emit('fromChange', index);
  }
</script>